import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { SessionService } from '@kimbocare/core';

/**
 * Matches when there is NO current group in storage. That signals a tenant
 * admin (medical advisor, support, etc.) — they don't belong to a benefit
 * group/company. Only in that case do we load the Tenant module.
 *
 * Subdomain detection is intentionally NOT used here anymore: the choice
 * between the tenant and root modules now depends solely on the auth state.
 */
export const isTenantDomainGuard: CanMatchFn = () => {
  const sessionService = inject(SessionService);
  return sessionService.getCurrentGroup() == null;
};

/**
 * Matches when there IS a current group in storage. That signals a benefit
 * (company) user — they belong to a group and stay on the root Features
 * module.
 *
 * Subdomain detection is intentionally NOT used here anymore: the choice
 * between the tenant and root modules now depends solely on the auth state.
 */
export const isRootDomainGuard: CanMatchFn = () => {
  const sessionService = inject(SessionService);
  return sessionService.getCurrentGroup() != null;
};
